import AppDispatcher from '../dispatcher/AppDispatcher';
import MoveMoneyConstants from '../constants/MoveMoneyConstants';
import AccountParser from '../parsers/AccountParser';
import { parsePaymentPotListResponse } from '../parsers/SavingsPotsParser';
import StringConstant from '../constants/StringConstants';
import DateUtils from '../utils/DateUtils';
import AppConstants from '../constants/AppConstants';
import MoveMoneyBL from '../components/movemoney/MoveMoneyBL';

class MoveMoneyActionCreator {
  raise(actionType, data) {
    AppDispatcher.handleViewAction({
      actionType,
      data,
    });
  }

  saveNavigationReference(url) {
    this.raise(MoveMoneyConstants.SET_MOVEMONEY_BACK_URL, url);
  }

  getFromAccountList() {
    AppDispatcher.handleViewAction({
      actionType: MoveMoneyConstants.GET_FROM_ACCOUNTS,
    });
  }

  handleAccountsListSuccess(response) {
    const accountParser = new AccountParser();
    const accountList = accountParser.parseAccountListResponse(response);
    AppDispatcher.handleServerAction({
      actionType: MoveMoneyConstants.GET_FROM_ACCOUNTS_SUCCESS,
      data: accountList,
    });
    accountList.map((account) => {
      this.getAccountDetails(account.id);
      return false;
    });
  }

  checkEndData(data) {
    AppDispatcher.handleViewAction({
      actionType: MoveMoneyConstants.SET_ENDING_DETAILS,
      data,
    });
  }

  getAccountDetails(accountId) {
    AppDispatcher.handleServerAction({
      actionType: MoveMoneyConstants.REQUEST_ACCOUNT_DETAIL,
      data: accountId,
    });
  }

  getPotDetails(accoundId) {
    AppDispatcher.handleServerAction({
      actionType: MoveMoneyConstants.REQUEST_POT_DETAILS,
      data: accoundId,
    });
  }

  handlePotsDetailsSuccess(response) {
    AppDispatcher.handleServerAction({
      actionType: MoveMoneyConstants.REQUEST_POT_DETAIL_SUCCESSS,
      data: parsePaymentPotListResponse(response),
    });
  }

  handleAccountsDetailsSuccess(response) {
    const accountParser = new AccountParser();
    const accountDetails = accountParser.parseAccountDetailResponse(response);
    AppDispatcher.handleServerAction({
      actionType: MoveMoneyConstants.REQUEST_ACCOUNT_DETAIL_SUCCESS,
      data: accountDetails,
    });
  }

  getFromPayeeList() {
    AppDispatcher.handleViewAction({
      actionType: MoveMoneyConstants.GET_FROM_PAYEES_MOVEMONEY,
    });
  }

  handlePayeesListSuccess(response) {
    AppDispatcher.handleServerAction({
      actionType: MoveMoneyConstants.GET_FROM_PAYEES_SUCCESS_MOVEMONEY,
      data: response,
    });
  }

  handlePayeeListError(response) {
    AppDispatcher.handleServerAction({
      actionType: MoveMoneyConstants.GET_FROM_PAYEES_FAILURE,
      data: response,
    });
  }

  putSelectedAccount(account) {
    AppDispatcher.handleViewAction({
      actionType: MoveMoneyConstants.PUT_SELECTED_ACCOUNT,
      data: account,
    });
  }

  putToSelectedAccount(account) {
    AppDispatcher.handleViewAction({
      actionType: MoveMoneyConstants.PUT_TO_SELECTED_ACCOUNT,
      data: account,
    });
  }

  putSelectedPayee(payee) {
    AppDispatcher.handleViewAction({
      actionType: MoveMoneyConstants.SELECT_PAYEEE,
      data: payee,
    });
  }

  postRepeatPaymentData(result) {
    AppDispatcher.handleViewAction({
      actionType: MoveMoneyConstants.POST_TO_STORE,
      data: result,
    });
  }

  makePayment(requestpackets) {
    const requestpacket = requestpackets;
    let makePaymentRequest = {};
    const accountId = requestpacket.accountId;
    const bankId = requestpacket.bankId;

    if (requestpacket.details) {
      switch (requestpacket.paymentType) {
        case StringConstant.transferUpper:
          makePaymentRequest.reference = requestpacket.payeeDetails.reference;
          makePaymentRequest.display_name =
            requestpacket.payeeDetails.display_name;
          if (requestpacket.payeeDetails.hasOwnProperty('account_id')) {
            makePaymentRequest.account_id =
              requestpacket.payeeDetails.account_id;
          } else {
            makePaymentRequest.account_number =
              requestpacket.payeeDetails.account_number;
            makePaymentRequest.sort_code = requestpacket.payeeDetails.sort_code;
          }

          break;
        case StringConstant.paymentUpper:
          makePaymentRequest.reference = requestpacket.details.reference;
          makePaymentRequest.beneficiary_id =
            requestpacket.payeeDetails.beneficiary_id;
          break;
      }
      if (!requestpacket.details.oneOffPayment) {
        makePaymentRequest.schedule = this.setRecurrenceData(
          requestpacket.details
        );
        makePaymentRequest.schedule.recurrence.amount = requestpacket.amount;
        makePaymentRequest =
          MoveMoneyBL.validateReferenceKey(makePaymentRequest);
        this.raise(MoveMoneyConstants.MAKE_SO_MOVEMONEY_SERVICECALL, {
          makePaymentRequest,
          accountId,
          bankId,
        });
      } else {
        const dateDifference = DateUtils.comapareFromCurrentDateSlashFormat(
          requestpacket.details.futureDate
        );
        switch (dateDifference) {
          case 0:
            let makePaymentRequestDD = {};
            makePaymentRequestDD.beneficiary_id =
              requestpacket.payeeDetails.beneficiary_id;
            makePaymentRequestDD.reference = requestpacket.details.reference;
            makePaymentRequestDD.amount = requestpacket.amount;
            makePaymentRequestDD =
              MoveMoneyBL.validateReferenceKey(makePaymentRequestDD);
            this.raise(MoveMoneyConstants.MAKE_DD_MOVEMONEY_SERVICECALL, {
              makePaymentRequestDD,
              accountId,
              bankId,
            });
            break;
          default:
            const when = DateUtils.getAPIDateString(
              requestpacket.details.futureDate
            );
            requestpacket.details.when = when;
            makePaymentRequest.single = {
              when,
              amount: requestpacket.amount,
            };
            makePaymentRequest =
              MoveMoneyBL.validateReferenceKey(makePaymentRequest);
            this.raise(MoveMoneyConstants.MAKE_SO_MOVEMONEY_SERVICECALL, {
              makePaymentRequest,
              accountId,
              bankId,
            });
        }
      }
    }
  }

  setRecurrenceData(repeatData) {
    const startDate = DateUtils.getAPIDateString(repeatData.startDate);
    const schedule = {
      start_condition: {
        when: startDate,
      },
      recurrence: {
        frequency: {},
      },
    };
    const seletedOftenType = repeatData.howOften.split(' ');
    switch (seletedOftenType[1]) {
      case StringConstant.weekly:
        schedule.recurrence.frequency.weekly = {
          interval: parseFloat(seletedOftenType[0]),
        };
        break;
      case StringConstant.monthly:
        schedule.recurrence.frequency.monthly = {
          interval: parseFloat(seletedOftenType[0]),
        };
        break;
      default:
    }
    switch (repeatData.stopWhen) {
      case '3':
        const end = DateUtils.getAPIDateString(repeatData.endValue);
        schedule.end_condition = {
          when: DateUtils.getAPIDateString(end),
        };
        break;
      case '2':
        schedule.end_condition = {
          number_of_payments: parseFloat(repeatData.endValue),
        };
        break;
    }

    return schedule;
  }

  goBackToRepeatPayment(data) {
    AppDispatcher.handleViewAction({
      actionType: MoveMoneyConstants.GO_BACK_TO_RP,
      data,
    });
  }

  selectedPot(sentPotData, accountID) {
    AppDispatcher.handleViewAction({
      actionType: MoveMoneyConstants.SELECTED_MoveMoneyPOT,
      data: {
        potData: sentPotData,
        selectedPotAccountID: accountID,
      },
    });
  }

  selectedToPot(sentPotData, accountID) {
    AppDispatcher.handleViewAction({
      actionType: MoveMoneyConstants.SELECTED_TO_MoveMoneyPOT,
      data: {
        toPotData: sentPotData,
        selectedToPotAccountID: accountID,
      },
    });
  }

  spendingTransferMoney(paymentDetails) {
    AppDispatcher.handleViewAction({
      actionType: MoveMoneyConstants.SPENDING_TRANSFER_MONEY,
      data: {
        ...paymentDetails,
        fromPayment: true,
      },
    });
  }

  toSavingTotalClick(data) {
    AppDispatcher.handleViewAction({
      actionType: MoveMoneyConstants.SAVING_TO_TOT_CLICK,
      data,
    });
  }

  potClicked(data) {
    AppDispatcher.handleViewAction({
      actionType: MoveMoneyConstants.MoveMoneyPOT_CLICKED,
      data,
    });
  }

  savingTotalClick(isClick) {
    AppDispatcher.handleViewAction({
      actionType: MoveMoneyConstants.SAVING_TOT_CLICKED,
      data: isClick,
    });
  }

  handleMakePaymentServiceCall(response) {
    switch (response.code) {
      case 202:
        AppDispatcher.handleViewAction({
          actionType: MoveMoneyConstants.MAKE_PAYMENT_SUCCESS,
          data: response,
        });
        break;
      case 422:
        AppDispatcher.handleServerAction({
          actionType: MoveMoneyConstants.MAKE_PAYMENT_FAILURE,
          data: response,
        });
        break;
      default:
    }
  }

  navigateToWebTask(taskId) {
    this.raise(AppConstants.NAVIGATE_TO_WEB_TASK_MOVEMONEY, { taskId });
  }

  resetData() {
    this.raise(AppConstants.RESET_DATA);
  }

  getMakePaymentRequestForPayee(payeeDetails, requestData) {
    const requestDataValue = requestData;
    requestDataValue.paymentRequestPacket.payeeDetails = {
      display_name: payeeDetails.display_name,
      beneficiary_id: payeeDetails.id,
    };
    if (payeeDetails.reference) {
      requestDataValue.paymentRequestPacket.payeeDetails.reference =
        payeeDetails.reference;
    }
    requestDataValue.paymentRequestPacket.payeeDetails =
      MoveMoneyBL.validateReferenceKey(
        requestDataValue.paymentRequestPacket.payeeDetails
      );
    if (payeeDetails.hasOwnProperty('account_id')) {
      requestDataValue.paymentRequestPacket.payeeDetails.account_id =
        payeeDetails.account_id;
    } else {
      requestDataValue.paymentRequestPacket.payeeDetails.account_number =
        payeeDetails.account_number;
      requestDataValue.paymentRequestPacket.payeeDetails.sort_code =
        payeeDetails.sort_code;
    }
    return requestDataValue.paymentRequestPacket;
  }

  handleSingleUsePayee(payeeDetails, requestData) {
    const makePaymentRequestData = this.getMakePaymentRequestForPayee(
      payeeDetails,
      requestData
    );
    this.makePayment(makePaymentRequestData);
  }

  generateInterPotTransferRequest(toSelectedPotId, amount) {
    const requestBody = {
      transaction: {
        amount,
        target_pot_id: toSelectedPotId,
      },
    };
    return requestBody;
  }

  getRequestDataForTransfer(selectedAccount) {
    const reqData = {
      display_name: selectedAccount.type,
      name: selectedAccount.product.name,
      single_use: true,
    };
    if (selectedAccount.type === 'credit_card') {
      reqData.display_name = selectedAccount.type.replace('_', ' ');
      reqData.account_id = selectedAccount.id;
    } else {
      reqData.sort_code = selectedAccount.sortCode;
      reqData.account_number = selectedAccount.accountNumber;
    }
    return reqData;
  }

  isSinglePayeeServiceRequired(requestpacket) {
    const {
      details: { futureDate, oneOffPayment = false },
    } = requestpacket;
    if (oneOffPayment) {
      const dateDifference =
        DateUtils.comapareFromCurrentDateSlashFormat(futureDate);
      return dateDifference === 0;
    }
    return false;
  }

  makeTransfer(
    fromSelectedAccount,
    toSelectedAccount,
    fromSelectedPot,
    toSelectedPot,
    requestPacket
  ) {
    const selectedAccountId = fromSelectedAccount.id;
    const paymentRequestPacket = requestPacket;
    const isSinglePayeeServiceRequired =
      this.isSinglePayeeServiceRequired(paymentRequestPacket);

    switch (fromSelectedAccount.type) {
      case StringConstant.savings:
        // Pot Transfer
        if (toSelectedAccount.type === StringConstant.savings) {
          let selectedPotId = fromSelectedPot;
          let toSelectedPotId = toSelectedPot;
          // Inter Saving Pot Transfer
          if (fromSelectedAccount.id === toSelectedAccount.id) {
            if (fromSelectedPot !== undefined) {
              // Not in pot Selected
              if (fromSelectedAccount.id === fromSelectedPot) {
                selectedPotId = StringConstant.unallocated;
                toSelectedPotId = toSelectedPot;
              } else if (toSelectedAccount.id === toSelectedPot) {
                toSelectedPotId = StringConstant.unallocated;
              } else {
                // Pot selected
                selectedPotId = fromSelectedPot;
                toSelectedPotId = toSelectedPot;
              }
              const requestData = this.generateInterPotTransferRequest(
                toSelectedPotId,
                paymentRequestPacket.amount
              );
              this.raise(
                MoveMoneyConstants.MAKE_INTER_POT_TRASNFER_SERVICECALL_MOVEMONEY,
                { requestData, selectedAccountId, selectedPotId }
              );
            }
          } else {
            // Intra Saving pot Transfer
            let requestData = this.getRequestDataForTransfer(toSelectedAccount);
            requestData.reference = paymentRequestPacket.details.reference;
            requestData = MoveMoneyBL.validateReferenceKey(requestData);
            this.raise(
              MoveMoneyConstants.CREATE_SINGLE_USE_PAYEE_SERVICECALL_MOVEMONEY,
              { requestData, selectedAccountId, paymentRequestPacket }
            );
          }
        } else {
          let requestData = this.getRequestDataForTransfer(toSelectedAccount);
          if (toSelectedAccount.type.toLowerCase() === 'credit_card') {
            paymentRequestPacket.details.reference = 'int trf to cc';
            requestData.reference = 'int trf to cc';
          } else {
            requestData.reference = paymentRequestPacket.details.reference;
          }
          requestData = MoveMoneyBL.validateReferenceKey(requestData);
          if (isSinglePayeeServiceRequired) {
            this.raise(
              MoveMoneyConstants.CREATE_SINGLE_USE_PAYEE_SERVICECALL_MOVEMONEY,
              { requestData, selectedAccountId, paymentRequestPacket }
            );
          } else {
            this.makePayment(paymentRequestPacket);
          }
        }
        break;
      default:
        let requestData = this.getRequestDataForTransfer(toSelectedAccount);
        if (toSelectedAccount.type.toLowerCase() === 'credit_card') {
          paymentRequestPacket.details.reference = 'int trf to cc';
          requestData.reference = 'int trf to cc';
        } else {
          requestData.reference = paymentRequestPacket.details.reference;
        }
        requestData = MoveMoneyBL.validateReferenceKey(requestData);
        if (isSinglePayeeServiceRequired) {
          this.raise(
            MoveMoneyConstants.CREATE_SINGLE_USE_PAYEE_SERVICECALL_MOVEMONEY,
            { requestData, selectedAccountId, paymentRequestPacket }
          );
        } else {
          paymentRequestPacket.payeeDetails = requestData;
          this.makePayment(paymentRequestPacket);
        }
    }
  }
}

export default new MoveMoneyActionCreator();
